import React, { useState } from "react";
import "./PlaygroundWidget.scss";
import PlaygroundTabs from "./playgroundTabs";
import NavigationTabs from "./navigation/NavigationTabs";
import AboutSection from "./about/AboutSection";
import ExamplesSection from "./examples/ExamplesSection";
import LiveChatSection from "./live-chat/LiveChatSection";
import ConnectSection from "./connect/ConnectSection";
import { UiModeContext } from "./context/UiModeContext";
import { ManageContext } from "./context/ManageContext";

const PlaygroundWidget = ({
  playground,
  uiMode = "LIGHT",
  manage = false,
  tab: initTab,
  showNavigation = true,
  // Admin-only overrides (undefined in public/embed contexts):
  liveChatAllowed,
  toolLimit,
  readOnly = false,
}) => {
  const [tab, setTab] = useState(initTab || PlaygroundTabs.ABOUT);
  const [counter, setCounter] = useState(0);

  // In manage/preview the entity has no `liveChatAvailable` flag (that's set only by the public
  // controller), so the caller passes the plan's capability explicitly. Public/embed falls back
  // to the backend-derived flag.
  const showLiveChat =
    liveChatAllowed !== undefined
      ? liveChatAllowed
      : manage || playground.liveChatAvailable;

  return (
    <UiModeContext.Provider value={{ uiMode }}>
      <ManageContext.Provider value={{ manage, toolLimit, readOnly }}>
        <div className={`playground_widget ${uiMode.toLowerCase()}_mode`}>
          {showNavigation && (
            <NavigationTabs
              tab={tab}
              showLiveChat={showLiveChat}
              onChange={(val) => {
                setTab(val);
                setCounter(counter + 1);
              }}
            />
          )}
          <div className="tab_content card">
            {tab === PlaygroundTabs.ABOUT && (
              <AboutSection playground={playground} setTab={setTab} />
            )}
            {tab === PlaygroundTabs.EXAMPLES && (
              <ExamplesSection
                key={"examples-" + counter}
                playground={playground}
              />
            )}
            {tab === PlaygroundTabs.LIVE_CHAT && (
              <LiveChatSection
                key={"live-chat-" + counter}
                playground={playground}
              />
            )}
            {tab === PlaygroundTabs.CONNECT && (
              <ConnectSection playground={playground} />
            )}
          </div>
        </div>
      </ManageContext.Provider>
    </UiModeContext.Provider>
  );
};

export default PlaygroundWidget;
